import { produce } from 'immer'
import { mountStoreDevtool } from 'simple-zustand-devtools'
import { create } from 'zustand'

type UpdateAccessManagementFormState = {
	isFormValid: boolean
	formValues: Record<string, any>
}

type UpdateAccessManagementFormActions = {
	actions: {
		clearFormValues: () => void
		setFormValues: (fieldName: string, value: any) => void
		setFormValidity: (isValid: boolean) => void
	}
}

const initialFormValues = {
	raciRoles: [] as Array<{ label: string; value: string }>,
	customPermissions: [] as Array<{ label: string; dismissLabel: string }>
}

const updateAccessManagementFormStore = create<
	UpdateAccessManagementFormState & UpdateAccessManagementFormActions
>((set, _get) => ({
	isFormValid: false,
	formValues: initialFormValues,
	actions: {
		clearFormValues: () => set(() => ({ formValues: initialFormValues })),

		setFormValidity: (isValid) => set(() => ({ isFormValid: isValid })),

		setFormValues: (fieldName, value) =>
			set((state) =>
				produce(state, (draft) => {
					draft.formValues[fieldName] = value
				})
			)
	}
}))

export const useUpdateAccessManagementStore = () =>
	updateAccessManagementFormStore((state) => state)

if (process.env.NODE_ENV !== 'production') {
	mountStoreDevtool(
		'UpdateAccessManagementFormStore',
		updateAccessManagementFormStore
	)
}
